/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de control de asistencia.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmControlAsistencia from "../../administracion/FrmControlAsistencia.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmControlAsistenciaPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmControlAsistencia">
      <FrmControlAsistencia />
    </SizeSoftXFrmPortatil>
  );
}
